import ChartTab from "./ChartTab";
import React from "react";
import _ from "lodash-es";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};

class ChartBudgetCategoryProjectTabPure extends React.Component {
  render() {
    const { data } = this.props;
    let pivots = [
      "project",
      "family",
      "category"
      //   "tiersGroup", "tiers"
    ];
    //  let pivots = [];
    let showColumns = [
      "project",
      "family",
      "category",
      "tiersGroup",
      "tiersAsClient",
      "dateMonthYear",
      "previousYearRealValueOrBudget",
      "budget",
      "realValue",
      "budgetVariation",
      "budgetVariationPourcent"
    ];

    if (!!data)
      for (let line of data) {
        // console.log("Line=", line);
        line.dateMonthYear = line.year + "-" + ("0" + line.month).slice(-2);
        line.budgetVariation = FIXED0(line.realValue - line.amount);

        if (line.amount !== 0)
          line.budgetVariationPourcent = _.round(
            (line.budgetVariation / line.amount) * 100.0,
            1
          );
        else line.budgetVariationPourcent = 0.0;
      }

    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "project")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={true}
        defaultSorted={[
          {
            id: "project",
            desc: false
          },
          {
            id: "family",
            desc: false
          },
          {
            id: "category",
            desc: false
          },
          {
            id: "tiersGroup",
            desc: false
          },
          {
            id: "tiers",
            desc: false
          },
          {
            id: "dateMonthYear",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartBudgetCategoryProjectTabPure;
